import React, { useEffect, useState } from 'react';
import AuthServices from '../services/AuthServices';

import '../styles/ConfirmationInscription.css';

function ConfirmationInscription() {
  const [newsletter, setNewsletter] = useState(true);
  const [connexionKey, setKey] = useState(null);

  useEffect(() => {
    if (!connexionKey) {
      const storedKey = AuthServices.getConnectedKey();
      if (storedKey) {
        setKey(storedKey);
      }
    }
  }, [connexionKey]);

  const handleContinue = () => {
    if (!connexionKey) {
      console.error('Connexion key missing, aborting preference save.');
      return;
    }
    const preferences = {
      connexionKey,
      newsletter,
    };

    fetch('https://app.listaki.fr/api/WS/save-preferences.php', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(preferences),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Preferences saved:', data);
      })
      .catch((error) => {
        console.error('Preferences save error:', error);
      })
      .finally(() => {
        window.location.href = '/';
      });
  };

  return (
    <div className="confirmation-container">
      <h1 className="confirmation-title">Bienvenue sur Listaki !</h1>

      <p className="confirmation-description">
        Votre compte a été créé avec succés.
      </p>

      <div className="preferences-section">
        <div className="preference-item">
          <input
            type="checkbox"
            checked={newsletter}
            onChange={(e) => setNewsletter(e.target.checked)}
            className="preference-checkbox"
            id="newsletter"
          />
          <label htmlFor="newsletter" className="preference-label">
            Je souhaite participer à la communauté Listaki (Mon mail ne sera pas transmis à des annonceurs publicitaires)
          </label>
        </div>
      </div>

      <button onClick={handleContinue} className="continue-button">
        Continuer vers Listaki
      </button>

      <p className="confirmation-footer">
        Vous pourrez modifier ces preferences a tout moment dans vos parametres.
      </p>
    </div>
  );
}

export default ConfirmationInscription;
